import { useContext, useEffect } from "react";
import { RegisterContext } from "../contexts/RegisterContext"
import { CheckKidSibling } from "./CheckKidSibling";
import { CheckboxAdvantage } from "./CheckboxAdvantage";
import { Dropdown } from 'primereact/dropdown';
import { AddressContext } from "../contexts/AddressContext";
import { SedentaryGroup } from "./SedentaryGroup";
import { ParameterContext } from "../contexts/ParameterContext";
import { WishValidatorContext } from "../contexts/WishValidatorContext";
import { AuthContext } from "../contexts/AuthContext";


export const Wish = ({ wish, index, formData, handleChange, removeWish, isEdit, cleanSiblingInputFields, onBlurWishHandler, isMunicipality, setAutoSedGroup }) => {
    const { advantages, schools } = useContext(RegisterContext);
    const { dontHaveCompletedGroup, siblingIsValid, addressResidence } = useContext(AddressContext);
    const { parameters } = useContext(ParameterContext);
    const { setIsSedGroupAuto } = useContext(WishValidatorContext);
    const { user } = useContext(AuthContext)

    const roles = ['Admin', 'SuperAdmin', 'Municipality'];

    let autoTimeLived;
    let dirDisableChildData;
    let munschrights;
    let showSchFreePlaces;

    if (parameters && parameters.nomParameters) {
        const autoTimeLivedParam = parameters.nomParameters.find(x => x.param_name == 'AUTOMATIC_TIME_LIVED');

        showSchFreePlaces = parameters.nomParameters.find(x => x.param_name == 'SHOW_SCH_FREE_PLACES');

        dirDisableChildData = parameters.nomParameters && parameters.nomParameters.length > 0 && parameters.nomParameters.find(x => x.param_name == 'DIR_DISABLE_CIHLD_DATA');
        munschrights = parameters.nomParameters.find(x => x.param_name == 'MUN_SCH_RIGHTS');

        autoTimeLived = autoTimeLivedParam ? autoTimeLivedParam.value : 0;
    } else {
        autoTimeLived = 0;
    }

    useEffect(() => {
        if (isMunicipality || autoTimeLived == 0 || (dirDisableChildData.value == 1 && user.role == 'Director')) {
            const autoSedGroupSet = setAutoSedGroup(index, wish);
            setIsSedGroupAuto(state => ({
                ...state,
                [index]: autoSedGroupSet
            }));
        }
    }, [siblingIsValid])


    const selectedSchoolTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center  font">
                    <div>{option.shortName}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const streetSchoolTemplate = (option) => {
        return (
            <div className="flex align-items-center  font">
                <div>{option.shortName}</div>
            </div>
        );
    };

    const renderSedGroups = () => {
        if (dirDisableChildData.value == 0 && user.role == 'Director') {
            return true;
        } else if (dirDisableChildData.value == 1 && user.role == 'Director') {
            if (autoTimeLived == 0) {
                return true;
            } else {
                return addressResidence.length == 0;
            }
        } else if (dirDisableChildData.value == 2 && user.role == 'Director') {
            return false;
        }

        if (isMunicipality || autoTimeLived == 0) {

            return true;
        }

        //if (dirDisableChildData.value == 0 && munschrights.value == 0) {
        //    return true;
        //}

        return false;
    }

    return (
        <>
            <p><b>Желание {index + 1}</b></p>
            <div className="children_data  mb-4 p-3-mob felx-mob flex-col-mob">
                <label className="col_school"><b>Училище</b></label>
                <Dropdown
                    name="school"
                    value={wish.school}
                    className="col_school_dropdown prime-dropdown-heigth  font w-100-mob"
                    options={showSchFreePlaces?.value == 1 ? schools.filter(x => x.freePlaces > 0) : schools}
                    optionLabel="name"
                    filter
                    placeholder='Изберете желаното от Вас училище'
                    valueTemplate={selectedSchoolTemplate}
                    itemTemplate={streetSchoolTemplate}
                    onChange={(e) => handleChange(e, index)}
                />
            </div>
            <>
                {formData.wishes[index].school &&
                    <div className='children_data mb-3 fade p-3-mob'>
                        <p><b>Предимства</b></p>
                        <div className="w-100 d-flex gap-3 flex-wrap ">
                            {advantages.map((x, i) => {
                                if (x.id == 10 || x.id == 20) {
                                    return <CheckKidSibling advantage={x} formData={formData} handleChange={handleChange} index={index} wish={wish} advIndex={x.id} isEdit={isEdit} cleanSiblingInputFields={cleanSiblingInputFields} onBlurWishHandler={onBlurWishHandler} isMunicipality={isMunicipality} setAutoSedGroup={setAutoSedGroup} />
                                } else if (x.isHideInSite != 1
                                    || (roles.includes(user.role) && x.isShowForMunicipality == 1 && x.isHideInSite == 1)) {
                                    return <>
                                        <CheckboxAdvantage advatage={x} formData={formData} handleChange={handleChange} index={index} wish={wish} advIndex={x.id} />
                                        {dontHaveCompletedGroup[index] && x.code == 'K50' && (<label className="text-danger w-100 ">{dontHaveCompletedGroup[index]}</label>)}
                                    </>
                                }
                            })}
                            {renderSedGroups() && <SedentaryGroup wish={wish} index={index} handleChange={handleChange} />}
                        </div>
                    </div>

                }
                {index > 0 && index == formData.wishes.length - 1 && (
                    <button className="btn btn-danger mb-3 mt-3" onClick={removeWish}>
                        Изтрий желание
                    </button>
                )}
            </>

        </>
    )
}